export default __webpack_public_path__ + "static/media/Cover3.92918f99.png";